module.exports = __webpack_public_path__ + "img/J10818.15314453.png";